const open = (redirectUrl?: string) =>
	redirectUrl ? window.open(redirectUrl, '_blank') : undefined;

export { open };
